import {useEffect} from 'react';
import {useLocation} from 'react-router';

/**
 * This component is designed to be used in the <AppRouter /> component. It scrolls
 * the screen to the top of the page when the pathname changes.
 * @returns {null} - No UI needed.
 */
export const ScrollToTopOnPathChange = () => {
  const {pathname} = useLocation();

  useEffect(() => {
    // Scroll to the top of the page when the pathname changes
    window.scrollTo({
      behavior: 'instant',
      top: 0,
    });
  }, [pathname]);

  return null; // No UI needed
};

export default ScrollToTopOnPathChange;
